"use client";

import clsx from "clsx";

import { useTradeStore, type Timeframe } from "@/stores/tradeStore";

const timeframes: Timeframe[] = ["1m", "5m", "15m", "1h", "4h", "1d", "1w", "1M"];

export const TimeframeSelector = () => {
  const { timeframe, setTimeframe } = useTradeStore();

  return (
    <div className="flex flex-wrap gap-2">
      {timeframes.map((tf) => (
        <button
          key={tf}
          onClick={() => setTimeframe(tf)}
          className={clsx(
            "rounded-full px-3 py-1 text-sm font-semibold transition",
            tf === timeframe
              ? "bg-slate-900 text-white shadow-sm"
              : "bg-white text-slate-700 border border-slate-200 hover:border-slate-300"
          )}
        >
          {tf}
        </button>
      ))}
    </div>
  );
};
